import { component } from "picoapp";
import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import styled from "styled-components";

let mysteryImg = "https://cdn.shopify.com/s/files/1/0110/7827/1033/files/questionmark-HJ.jpg"

const getEtchStyles = (props) => {
  let desktopJugStyleString = "";
  let mobileJugStyleString = "";
  let desktopEtchStyleString = "";
  let mobileEtchStyleString = "";
  if (props.$font) {
    desktopEtchStyleString += `font-family: ${props.$font};`
  }
  switch (props.$jugType) {
    case "Traveler (40oz)":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 10%;"
      } else {
        desktopJugStyleString += "top: 29%"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:18px;" : "font-size:14px;"
        mobileEtchStyleString += "font-size:14px;"
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:20px;" : "font-size:16px;"
        mobileEtchStyleString += "font-size:16px;"
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:24px;" : "font-size:18px;"
        mobileEtchStyleString += "font-size:20px;"
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:28px;" : "font-size:23px;"
        mobileEtchStyleString += "font-size:24px;"
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:32px;" : "font-size:29px;"
        mobileEtchStyleString += "font-size:28px;"
      } else {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:36px;" : "font-size:35px;"
        mobileEtchStyleString += "font-size:32px;"
      }
      break;
    case "Traveler (32oz)":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 18%;#designImg{width:105px;}"
        mobileJugStyleString += "top: 16%"
      } else {
        desktopJugStyleString += "top: 33%;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:14px;";
        mobileEtchStyleString += "font-size: 14px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 16px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:18px;";
        mobileEtchStyleString += "font-size: 20px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:23px;";
        mobileEtchStyleString += "font-size: 24px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:29px;";
        mobileEtchStyleString += "font-size: 28px;";
      } else {
        desktopEtchStyleString += "font-size:35px;"
        mobileEtchStyleString += "font-size: 32px;";
      }
      break;
    case "Traveler (20oz)":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 32%;left: 14px;#designImg{width:90px;}"
        mobileJugStyleString += "#designImg{width:85px;}"
      } else {
        desktopJugStyleString += "top: 46%;left: 14px;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:12px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:14px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 18px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:20px;";
        mobileEtchStyleString += "font-size: 22px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:26px;";
      } else {
        desktopEtchStyleString += "font-size:34px;"
        mobileEtchStyleString += "font-size: 30px;";
      }
      break;
    case "Sport (32oz)":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 20%;#designImg{width:95px;}"
        mobileJugStyleString += "top: 23%;"
      } else {
        desktopJugStyleString += "top: 33%;"
        mobileJugStyleString += "top: 38%;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:12px;";
        mobileEtchStyleString += "font-size: 10px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:14px;";
        mobileEtchStyleString += "font-size: 10px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 14px;";

      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:18px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:23px;";
      } else {
        desktopEtchStyleString += "font-size:25px;"
      }
      
      break;
    case "Stainless 64oz":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 42.5%;"
      } else {
        desktopJugStyleString += "top: 57.5%;"
        mobileJugStyleString += props.$direction === "vertical" ? "top:61%;" : "top: 58%;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 12px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:20px;";
        mobileEtchStyleString += "font-size: 14px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:24px;";
        mobileEtchStyleString += "font-size: 16px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:28px;";
        mobileEtchStyleString += "font-size: 18px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:32px;";
        mobileEtchStyleString += "font-size: 21px;";
      } else {
        desktopEtchStyleString += "font-size:34px;"
        mobileEtchStyleString += "font-size: 23px;";
      }
      break;
    case "Shaker":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 30%; left: 8px;#designImg{width:90px;}";
      } else {
        if (props.$direction === "vertical") {
          if (props.$length >= 8) {
            desktopJugStyleString += "top: 51%; left: 8px;";
          } else {
            desktopJugStyleString += "top: 49%; left: 8px;";
          }
        } else {
          desktopJugStyleString += "top: 40%; left: 8px;";
        }
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:10px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:11px;";
        mobileEtchStyleString += "font-size: 12px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:13px;";
        mobileEtchStyleString += "font-size: 14px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:17px;";
        mobileEtchStyleString += "font-size: 16px;";
        if (props.$direction === "vertical") {
          desktopJugStyleString += "top: 51%;";
        }
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:22px;";
        mobileEtchStyleString += "font-size: 20px;";
      } else {
        desktopEtchStyleString += "font-size:25px;"
        mobileEtchStyleString += "font-size: 23px;";
      }
      break;
  
    default:
      break;
  }
  if (props.$direction === "vertical") {
    desktopEtchStyleString += "transform: rotate(90deg);"
  }

  console.log("deskJug", desktopJugStyleString);
  return `${desktopJugStyleString};
  #Result {
    ${desktopEtchStyleString};
  }
  @media screen and (max-width: 767px){
    ${mobileJugStyleString};
    #Result {
      ${mobileEtchStyleString};
    }
  }
  `
};
const StyledJugImage = styled.div.attrs(props => ({
  $jugType: props.$jugType,
  $etchType: props.$etchType,
  $length: props.$length || 1,
  $direction: props.$direction,
  $font: props.$font
}))`
  ${props => getEtchStyles(props)}
`
const fonts = ["Arial", "Times New Roman", "Verdana", "Impact", "Cursive", "Lemon Jelly", "Comic Sans", "Paroli", "Attraction", "Lovely Coffee"]

function StepOne({collectionTitles, selectedJugType, setSelectedJugType, setSelectedJug, collections}) {

  return (
    <li className="stepSection stepSection1" alt="step 1">
    <p id="selectedJugName" className="step-show">Step 1</p>
    <div id='step-1' className=''>
      {collections.length && collections.map((coll, i) => (
        <p
        key={i} 
        id={`step1_text${i+1}`} 
        className={`stepSpan step1_text step_text ${coll.title === selectedJugType ? "is-active" : ""}`}
        onClick={()=> {
          setSelectedJugType(coll.title)
          setSelectedJug(coll.products[0]);
        }}
        >
          {coll.title}
        </p>
        
      ))}
    </div>
    
    {collections.length > 0 && collections.map((collection, i) => 
    {
      return <ul key={i} id='' className={`jugSelection inner ${collection.title === selectedJugType ? "is-active" : ""}`}>
          {collection.products?.map((prod, i) => 
              <img 
              key={i} 
              className="ssImg" 
              loading="lazy" 
              src={prod.variants?.nodes[0]?.image?.url}
              onClick={()=> setSelectedJug(prod)}
              />
            )}
        </ul>
    })}
  </li>
  )
}
function StepTwo({selectedEtchType, setSelectedDesignCategory, setSelectedEtchType, selectedDesignCategory, etchings, setSelectedDesign, customText, setCustomText, selectedFont, setSelectedFont, textDirection, setTextDirection, customTextItem}) {
  
  return (
  <li className="stepSection" alt="step 2">
    <p id="selectedDesignName" className="step-show">Step 2</p>
    <div id='step-2' className=''> 
      <p className={`stepSpan ${selectedEtchType === "design" ? "is-active" : ""}`} onClick={()=> {
        setSelectedEtchType("design")
        setSelectedDesign(null);
        }}>
        DESIGNS
      </p>
      <p className={`stepSpan ${selectedEtchType === "text" ? "is-active" : ""}`} onClick={()=> {
        setSelectedEtchType("text")
        setSelectedDesign(customTextItem);
        }}>
        TEXT
      </p>
    </div>
    
    {selectedEtchType === "design" ? 
    
    <ul id='pickDesignToggle' className="designSelection inner" alt="pick a design">
      <span id="backBTN" onClick={()=> setSelectedDesignCategory(null)}>
        <svg aria-hidden="true" focusable="false" fill="none" width="12" className="icon icon-arrow-left  icon--direction-aware" viewBox="0 0 16 18">
          <path d="M11 1 3 9l8 8" stroke="currentColor" strokeLinecap="square"></path>
        </svg>
      </span>
      <div id="designSelectionOriginal">
        {etchings.length > 0 && etchings.map((prod, i) => (
            <div key={i} className={`tagWrap ${prod.title === selectedDesignCategory?.title ? "is-active" : ""}`} alt="tag wrap" onClick={()=> setSelectedDesignCategory(prod)}>
              <img className="selectedDesignImg" loading="lazy" src={prod.variants?.nodes[0]?.image?.url}/>
              <p className="selectedDesignTitle">{prod.title}</p>
              <div id="designSelection1" className="designSelection1" >
                {prod.variants?.nodes?.map((variant, i) => (
                    <div key={i} className="tagWrap--inner" name="" onClick={()=> setSelectedDesign(variant)}>
                      <img className="selectedVariantImg" loading="lazy" src={variant.image?.url}/>
                      <p id=""></p>
                    </div>
                ))}
              </div>
            </div>
        ))}
      </div>
    </ul>
    : 
    <ul id='customTextToggle' className="designSelection inner">
      <span id="backBTN">
        <svg aria-hidden="true" focusable="false" fill="none" width="12" className="icon icon-arrow-left  icon--direction-aware" viewBox="0 0 16 18">
          <path d="M11 1 3 9l8 8" stroke="currentColor" strokeLinecap="square"></path>
        </svg>
      </span>
      <div id="customTextWrapper">
        <div className="input-font-wrapper">
          <div className="input-wrapper">
            <span id="maxChars">Characters Exceed Etch Limit</span>
            <input type="text" maxLength={15} className="tb" id="member" name="tb_" value={customText} onChange={(e)=> setCustomText(e.target.value)}/>
            <span className="numberOf" alt="number of  text allowed">
              Number of characters: (max. 15)
            </span>
          </div>
          <select id="font-dropdown" value={selectedFont} defaultValue={"init"} onChange={(e)=>setSelectedFont(e.target.value)}>
            <option disabled value="init">Select Font</option>
            {fonts.map((font,i) => (
              <option key={i} value={font}>{font}</option>
            ))}
          </select>
        </div>
        <div>
          <span className="toggle-step">Text Direction</span>
          <div className="toggle-wrapper">
            <div className={`stepSpan ${textDirection === "horizontal" ? "is-active" : ""}`} onClick={()=> setTextDirection("horizontal")}>Horizontal</div>
            <div className={`stepSpan ${textDirection === "vertical" ? "is-active" : ""}`} onClick={()=> setTextDirection("vertical")}>Vertical</div>
          </div>
        </div>
      </div>
    </ul>
    }
  </li>
  )
}
function StepThree({selectedJug, customText, selectedDesign, selectedEtchType, textDirection, selectedFont, customTextItem}) {
  let body = {
    items: []
  };
  let batchId = Math.floor(Math.random() * 1000000);
  if (selectedJug && selectedDesign) {
    
  
  if (selectedEtchType === "design") {
    body.items = [
      { 
        quantity: 1, 
        id: Number(selectedJug.variants?.nodes[0].storefrontId.replace("gid://shopify/ProductVariant/","")), 
        properties: {
          etchInfo: {
          'etchType': 'design',
          'designId': selectedDesign.title,
          '_batchId': batchId
        },
          'Customization': 'Laser Etch',
          'Notice': 'Final Sale'
        } 
      },
      { 
        quantity: 1, 
        id: Number(selectedDesign.storefrontId.replace("gid://shopify/ProductVariant/","")),
        properties: {
          etchInfo: {
            'etchType': 'design',
            'designId': selectedDesign.title,
            '_batchId': batchId
          },
          'Customization': 'Laser Etch',
          'Notice': 'Final Sale'
        } 
      }
    ];
  } else {
    body.items = [
      { 
        quantity: 1, 
        id: Number(selectedJug.variants?.nodes[0].storefrontId.replace("gid://shopify/ProductVariant/","")), 
        properties: {
          etchInfo: {
          'etchType': 'text',
          'text': customText,
          'textDirection': textDirection,
          'font': selectedFont,
          '_batchId': batchId
          },
          'Notice': 'Final Sale'
        } 
      },
      { 
        quantity: 1, 
        id: Number(customTextItem.variants?.nodes[0].storefrontId.replace("gid://shopify/ProductVariant/","")),
        properties: {
          etchInfo: {
            'etchType': 'text',
            'text': customText,
            'textDirection': textDirection,
            'font': selectedFont,
            '_batchId': batchId
            },
          'Notice': 'Final Sale'
        } 
      }
    ];
  }
}
  const handleSubmit = () =>{
    console.log("items:", body)
    fetch("/cart/add.js", {
      "method": "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
    .then(res => {
      res.json().then(res => {
        console.log("added", res);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.querySelector("cart-drawer").show();
      })
    })
    .catch(err => {
      console.log("couldn't add", err);
    })
  }
  return (
    <li className="" alt="step 3">
      <div className="reviewSelection inner">
        <p alt="summary" className="summary-title">Summary:</p>
        <div className="summaries">
          <div id='jugSummary'>
            <img id="summaryImg" loading="lazy" src={selectedJug?.featuredImage?.src || mysteryImg}/>
            <div>
              <p id='summaryJugTitle' alt="jug title">{selectedJug?.title || "Pick A Stainless HydroJug"}</p>
              <p id='summaryJugPrice' alt="jug price">{selectedJug?.variants?.nodes[0]?.price || null}</p>
            </div>
          </div>
          <span>+</span>
          <div id='designSummary'>
            {selectedEtchType === "text" ?
            <>
              <img id="summaryDesign" loading="lazy" src={selectedDesign?.featuredImage?.src || mysteryImg}/>
              <div>
                <p id='summaryDesignTitle' alt="design title">{customText || "Enter your text"}</p>
                <p id='summaryDesignPrice' alt="design price">{customTextItem?.variants?.nodes[0].price || null}</p>
              </div>
            </>
            : 
            <>
              <img id="summaryDesign" loading="lazy" src={selectedDesign?.image?.src || mysteryImg}/>
              <div>
                <p id='summaryDesignTitle' alt="design title">{selectedDesign?.title || "Pick a Design"}</p>
                <p id='summaryDesignPrice' alt="design price">{selectedDesign?.price || null}</p>
              </div>
            </>
            }
          </div>
        </div>
        {selectedDesign && selectedJug && 
        <>
        <p aria-label="total price" className="total-price">Total: <span id="totalPrice" aria-label="total price">${(Number(selectedDesign?.price || customTextItem?.variants?.nodes[0].price) + Number(selectedJug?.variants?.nodes[0]?.price)).toFixed(2)}</span></p>
        <button name="checkout"
          onClick={handleSubmit} 
          
          disabled={(selectedJug && selectedDesign) || (selectedJug && selectedEtchType === "text" && customText) ? false : true} 
          id="checkoutButton"
          alt="checkout button" 
          aria-label="checkout-button" 
          type="" 
          className="collection-add-to-cart action_button add_to_cart">
            ADD TO CART
        </button>
        </>
        }
      </div>
    </li>
  )
}
function CustomizerGQL() {
  let collectionIds = [288096583737,288096550969,288088490041,288096518201,288088522809,291721936953]
  let collectionHandles = ["traveler-40oz", "traveler-32oz", "traveler-20oz", "sport-32oz", "stainless-64oz", "shkr"]
  let collectionTitles = ["Traveler (40oz)", "Traveler (32oz)", "Traveler (20oz)", "Sport (32oz)", "Stainless (64oz)", "Shaker"]
  let etchingTitle = "Etching Designs"
  const [collections, setCollections] = useState([]);
  const [selectedJugType, setSelectedJugType] = useState("Traveler (40oz)")
  const [selectedJug, setSelectedJug] = useState()
  const [selectedEtchType, setSelectedEtchType] = useState("design")
  const [etchings, setEtchings] = useState([]);
  const [selectedDesignCategory, setSelectedDesignCategory] = useState()
  const [selectedDesign, setSelectedDesign] = useState();
  const [customText, setCustomText] = useState("");
  const [textDirection, setTextDirection] = useState("horizontal");
  const [selectedFont, setSelectedFont] = useState();
  const [customTextItem, setCustomTextItem] = useState();
  
  useEffect(() => {
    const fetchProducts = async () => {
    for (let title in collectionTitles) {
      try {
        const response = await fetch('/admin/api/2023-10/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Access-Token': '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',
          },
          
          body: JSON.stringify({
            query: `
              {
                collections(query:"title:${collectionTitles[title]}", first: 1) {
                  nodes {
                    handle
                    title
                    products(first: 100) {
                      nodes {
                        publications(first: 50) {
                          nodes {
                            isPublished
                            channel {
                              name
                            }
                          }
                        }
                        featuredImage {
                          url
                          src
                        }
                        storefrontId
                        title
                        createdAt
                        variants(first: 1) {
                          nodes {
                            price
                            storefrontId
                            image {
                              url
                              src
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            `,
          }),
        });

        const result = await response.json();
        if (result.errors) {
          throw new Error(result.errors[0].message);
        }
        const collection = result.data.collections.nodes[0]
        let products = []
        for (let prod in collection.products.nodes){
          let currentProd = collection.products.nodes[prod];
          currentProd.publications.nodes.forEach(pub => {
            if (pub.channel.name === "Online Store" && pub.isPublished) {
              products.push(currentProd);
            }
          })
        }
        console.log("coll:", collection);
        console.log("prodsss:", products);
        collection.products = products;
        setCollections((prev)=> [...prev, collection]);
      } catch (error) {
        console.log("errror", error)
      } 
    }
    try {
      const response = await fetch('/admin/api/2023-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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',
        },
        
        body: JSON.stringify({
          query: `
            {
              collections(query:"title:${etchingTitle}", first: 1) {
                nodes {
                  handle
                  title
                  products(first: 30) {
                    nodes {
                      storefrontId
                      title
                      createdAt
                      variants(first: 100) {
                        nodes {
                          metafield(key: "etching_brushed_design", namespace: "my_fields") {
                            value
                            reference {
                              ... on MediaImage {
                                id
                                image {
                                  url
                                  altText
                                  width
                                  height
                                }
                              }
                            }
                          }
                          storefrontId
                          price
                          title
                          image {
                            url
                            src
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
        }),
      });

      const result = await response.json();
      if (result.errors) {
        throw new Error(result.errors[0].message);
      }
      const products = result.data.collections.nodes[0].products.nodes;
      setEtchings(products);
    } catch (error) {
      console.log("errror", error)
    } 
    try {
      const response = await fetch('/admin/api/2023-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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',
        },
        
        body: JSON.stringify({
          query: `
            {
              products(query:"title:Custom Text", first: 1) {
                nodes {
                  storefrontId
                  title
                  createdAt
                  featuredImage {
                    url
                    src
                  }
                  variants(first: 100) {
                    nodes {
                      price
                      storefrontId
                      title
                      image {
                        url
                        src
                      }
                    }
                  }
                }
              }
            }
          `,
        }),
      });

      const result = await response.json();
      if (result.errors) {
        throw new Error(result.errors[0].message);
      }
      const product = result.data.products.nodes[0];
      setCustomTextItem(product);
    } catch (error) {
      console.log("errror", error)
    } 
    };

    fetchProducts();
  }, []);
  useEffect(()=>{
    console.log("coll", collections);
  },[collections]);
  return (
    <div>
      <div id="itemsAdded" alt="items added">
        Putting it all together for you!
        <br/>
        <img src="" alt="Packaging It Up" className="packagingGif"/>
      </div>
      {collections.length > 0 && 
      <div className="custom-container">
        <div className="customImg">
          {selectedJug?.variants?.nodes[0]?.image?.url ? 
          <>
            <img id="selectedImg" loading="lazy" src={selectedJug?.variants?.nodes[0]?.image?.url} alt="etchedJug" />
            <StyledJugImage className="customDesign" $jugType={selectedJugType} $font={selectedFont} $etchType={selectedEtchType} $direction={textDirection} $length={customText?.length}>
              {selectedEtchType === "design" ? selectedDesign && <img id="designImg" loading="lazy" src={selectedDesign?.metafield?.reference?.image?.url} alt="customDesign"/> : <div id="Result" >{customText}</div>}
            </StyledJugImage>
          </> : <h3>Select a Jug to Begin!</h3>
          }
        </div>
        <div className="custom-navigation">
          <div className="headerWrapper">
            <h1 className="headerTitle" alt="header title">HydroJug You</h1>
            <p className="subTitle" alt="subtitle">Laser Etch a Stainless Sport, Shaker, or Traveler Below!</p>
            <p className="disclaimer">*All renderings are strictly a visual representation. Actual results may vary.</p>
          </div>
          <ul className="unstyled-list">
            {collections && 
              <StepOne collections={collections} selectedJugType={selectedJugType} setSelectedJugType={setSelectedJugType} collectionTitles={collectionTitles} setSelectedJug={setSelectedJug}/>
            }
            {etchings && selectedJug && 
              <StepTwo customTextItem={customTextItem} textDirection={textDirection} setTextDirection={setTextDirection} selectedFont={selectedFont} setSelectedFont={setSelectedFont} customText={customText} setCustomText={setCustomText} etchings={etchings} setSelectedDesign={setSelectedDesign} selectedEtchType={selectedEtchType} setSelectedEtchType={setSelectedEtchType} setSelectedDesignCategory={setSelectedDesignCategory} selectedDesignCategory={selectedDesignCategory}/>
            }
            {selectedDesign || selectedJug ? 
              <StepThree customTextItem={customTextItem} textDirection={textDirection} selectedFont={selectedFont} selectedEtchType={selectedEtchType} selectedDesign={selectedDesign} selectedJug={selectedJug} customText={customText}/>
            :
              <div className="emptyCart">Select a Jug and Design!</div>
            }
            <p className="disclosure" alt="disclosure" aria-label="disclosure final sale">
              *Customized Items Are Final Sale*
              <br />
              *Please Allow 1-3 Days For Processing*
            </p>
          </ul>
        </div>
      </div>
      }
    </div>
  )
}
export default component((node, ctx) => {
  const element = <CustomizerGQL node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
